import { AxiosError } from "axios"

import { ErrorCode } from "@shared/enums/errorCode"

/** Disable ESlint rule here, since we try to convert the `any` type to something useful */

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

interface HttpErrorInfo {
  status?: number
  message: string
  isHttpError: boolean
  errorCode?: ErrorCode // Shortcut to `response.data.errorCode`
}

/**
 * Type guard helper function to get the status code from HTTP errors
 */
export const getHttpErrorInfo = (error: unknown): HttpErrorInfo => {
  // Handle AxiosError specifically
  if (error instanceof AxiosError) {
    return {
      status: error.response?.status,
      message: error.message,
      isHttpError: true,
      errorCode: error.response?.data?.errorCode,
    }
  }

  // Handle generic HTTP error structure
  if (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    typeof (error as any).response === "object"
  ) {
    const response = (error as any).response

    return {
      status: response && typeof response.status === "number" ? response.status : undefined,
      message: (error as any).message ?? "Error accessing API.",
      isHttpError: true,
      errorCode: response.data?.errorCode,
    }
  }

  // Not an HTTP error
  return {
    status: undefined,
    message: "Error accessing API.",
    isHttpError: false,
    errorCode: undefined,
  }
}
